import { makeAutoObservable } from 'mobx';

class ScreenStore {
  isMobile = false;
  isTablet = false;
  isLaptop = false;
  isLaptopL = false;

  constructor() {
    makeAutoObservable(this);
  }

  setIsMobile(isMobile: boolean) {
    this.isMobile = isMobile;
  }

  setIsTablet(isTablet: boolean) {
    this.isTablet = isTablet;
  }

  setisLaptop(isLaptop: boolean) {
    this.isLaptop = isLaptop;
  }

  setisLaptopL(isLaptopL: boolean) {
    this.isLaptopL = isLaptopL;
  }
}

export const screenStore = new ScreenStore();